module.exports = __webpack_public_path__ + "img/DistinctHealthcare.ab23cf71.jpg";